import React, { useRef, useState } from "react";
import styled from "styled-components";
import { useStaticQuery, graphql } from "gatsby";
import { useIntl, navigate } from "gatsby-plugin-intl";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import get from "lodash/get";
import KCButton from "Components/KCButton";

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledModal = styled.div`
  margin: 1rem;
  background-color: ${(props) => props.theme.color[props.backgroundColor]};
  color: ${(props) => props.theme.color[props.textColor]};
  padding: 4rem 10%;
  text-align: center;
  ${(props) => props.theme.responsive.desktop} {
    padding: 4rem 30%;
  }
`;

const StyledTitle = styled.div`
  font-size: 1.2rem;
  font-weight: 600;
`;

const StyledDescription = styled.div`
  font-size: 0.8rem;
  margin-top: 0.3rem;
`;

const StyledRender = styled.div`
  width: 100%;
  margin-top: 2rem;
`;
const StyledCTAWrapper = styled.div`
  margin-top: 0.8rem;
  display: flex;
  justify-content: center;
  & > *:not(:first-child) {
    margin-left: 0.4rem;
  }
`;

export default function SocialModal({
  title,
  description,
  textColor,
  backgroundColor,
  image,
  ctas,
}) {
  const intl = useIntl();

  return (
    <StyledWrapper>
      <StyledModal
        textColor={textColor.color}
        backgroundColor={backgroundColor.color}
      >
        <StyledTitle>{get(title, intl.locale, "")}</StyledTitle>
        <StyledDescription>
          {get(description, intl.locale, "")}
        </StyledDescription>
        <StyledRender>
          {image && (
            <GatsbyImage
              objectFit="contain"
              objectPosition="center"
              style={{ width: "100%", height: "100%" }}
              image={getImage(image.imageFile)}
              alt="image"
            />
          )}
        </StyledRender>
        <StyledCTAWrapper>
          {ctas &&
            ctas.map((cta, i) => {
              return (
                <KCButton
                  buttonType={cta.type}
                  size="small"
                  isInvert={backgroundColor.color === "black"}
                  key={`contentModal-cta-${i}`}
                  label={get(cta, `label[${intl.locale}]`, "")}
                  buttonType={cta.type}
                  handleClick={() => navigate(cta.link)}
                />
              );
            })}
        </StyledCTAWrapper>
      </StyledModal>
    </StyledWrapper>
  );
}

export const query = graphql`
  fragment imageBlurbModal on STRAPI_ComponentBaseImageBlurbModal {
    __typename
    id
    title {
      en
      es
      it
    }
    description {
      en
      es
      it
    }
    ctas {
      label {
        en
        es
        it
      }
      link
      type
    }
    backgroundColor {
      color
    }
    textColor {
      color
    }
    image {
      url
      imageFile {
        childImageSharp {
          gatsbyImageData(
            layout: FULL_WIDTH
            placeholder: BLURRED
            formats: AUTO
          )
        }
      }
    }
  }
`;
